import { render, staticRenderFns } from "./SecMatchingTaskItem.vue?vue&type=template&id=42c68fd7&scoped=true&"
import script from "./SecMatchingTaskItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./SecMatchingTaskItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SecMatchingTaskItem.vue?vue&type=style&index=0&id=42c68fd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c68fd7",
  null
  
)

export default component.exports